import BpkBadge, {
  BADGE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-badge';
import BpkCard from '@skyscanner/backpack-web/bpk-component-card';
import CleanIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/clean';
import ThumbSmIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/thumbs-up';
import BpkImage from '@skyscanner/backpack-web/bpk-component-image';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { SubRating } from '@shared/types/hotel-content';

import STYLES from './ConfidentCardList.module.scss';

import { ICON_URL_MAPPING } from '@shared/ui/components/ConfidentMessage/RecommendMessage/confident-card';

const cls = cssModules(STYLES);

type Props = {
  excellentSubratings: SubRating[];
  confidentReview?: string;
  isMobile?: boolean;
};

const ConfidentCardList = ({
  confidentReview,
  excellentSubratings,
  isMobile,
}: Props) => (
  <div className={cls('ConfidentCardList')}>
    {excellentSubratings.map(({ description, type }) =>
      isMobile ? (
        <BpkBadge type={BADGE_TYPES.normal} key={type}>
          {type === 'RATING_TYPE_SERVICE' ? <CleanIcon /> : <ThumbSmIcon />}
          <BpkText
            textStyle={TEXT_STYLES.caption}
            className={cls('ConfidentCardList__item')}
          >
            {description}
          </BpkText>
        </BpkBadge>
      ) : (
        <BpkCard
          className={cls('ConfidentCardList__card')}
          key={type}
          atomic={false}
        >
          <BpkImage
            src={ICON_URL_MAPPING[type]}
            altText=""
            className={cls('ConfidentCardList__img')}
            aspectRatio={24 / 26}
          />
          <BpkText textStyle={TEXT_STYLES.caption}>{description}</BpkText>
        </BpkCard>
      ),
    )}

    {!isMobile && confidentReview && (
      <BpkCard
        className={cls('ConfidentCardList__card')}
        atomic={false}
        aria-hidden="true"
      >
        <BpkText
          textStyle={TEXT_STYLES.caption}
          className={cls(
            'ConfidentCardList__lastItem',
            'ConfidentCardList__lastItem--review',
          )}
          color={TEXT_COLORS.textPrimary}
        >
          {`"${confidentReview}"`}
        </BpkText>
      </BpkCard>
    )}
  </div>
);

export default ConfidentCardList;
